// LoadingIndicator.js
import React from 'react';
import { useLoading } from './LoadingContext';
import './loading.css'; // Assume you create CSS for this
import loadingConfig from '../../assets/animations/loading2.json'
import Lottie from 'react-lottie';


const LottieLoader = () => {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: loadingConfig,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };
  
    return <Lottie options={defaultOptions} height={100} width={200} />;
  };
const LoadingIndicator = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-spinner">
        {/* You can use any spinner here. For example, a simple div or a library component */}
        <LottieLoader />
        <div className="loading-text">Loading...</div>
        
      </div>
     
    </div>
  );
};

export default LoadingIndicator;
